<template>
  <div v-if="item" class="listing-score-field" :class="fieldScoreTierClass" aria-live="polite">
    <div>Skor diperoleh: {{ earnedScore }} / {{ maxScore }}</div>
    <div class="listing-score-field__hint">
      <span class="listing-score-field__hint-icon" aria-hidden="true">💡</span>
      <span>{{ scoreAdvice }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

const FIELD_ADVICE = {
  VALID_GEO_POINT: 'Tentukan lokasi pin yang valid pada peta.',
  PHOTO_COUNT: 'Tambahkan foto properti sampai jumlah target untuk memperoleh skor maksimal.',
  FACILITY_EXISTS: 'Pilih minimal satu fasilitas yang tersedia pada properti.',
  CATEGORY_NAME: 'Isi nama perumahan, cluster, atau kawasan properti.',
  UNIT_NUMBER: 'Isi nomor unit properti.',
  UNIT_BLOCK: 'Isi nomor blok properti.',
  VIDEO_URL: 'Tambahkan minimal satu video properti atau URL video yang valid.',
  LAND_SIZE: 'Isi luas tanah properti.',
  TOTAL_FLOOR: 'Isi jumlah lantai bangunan.',
  FLOOR: 'Isi posisi lantai unit.',
  BEDROOM: 'Isi jumlah kamar tidur.',
  BATHROOM: 'Isi jumlah kamar mandi.',
  BUILDING_SIZE: 'Isi luas bangunan properti.',
  ELECTRICAL_POWER: 'Isi daya listrik properti.',
  HOEK: 'Pilih status rumah hoek.',
  FURNISHING_STATUS: 'Pilih status furnishing properti.',
};

export default {
  name: 'listing-score-field',
  props: {
    fieldCode: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({
      listingScorePreview: (state) => state.listingForm.listingScorePreview,
    }),
    scoreData() {
      const preview = this.listingScorePreview;
      if (!preview) return null;
      if (preview.score) return preview.score;
      if (preview.data && preview.data.score) return preview.data.score;
      return preview.data || preview;
    },
    item() {
      const items = Array.isArray(this.scoreData?.items) ? this.scoreData.items : [];

      return (
        items.find((item) => {
          const code = item.field_code || item.fieldCode || item.rule_code || item.ruleCode;
          return String(code || '').toUpperCase() === this.fieldCode.toUpperCase();
        }) || null
      );
    },
    earnedScore() {
      return this.item?.earned_score ?? this.item?.earnedScore ?? 0;
    },
    maxScore() {
      return this.item?.max_score ?? this.item?.maximum_score ?? this.item?.maxScore ?? 0;
    },
    targetValue() {
      return this.item?.target_value ?? this.item?.targetValue;
    },
    fieldScoreTierClass() {
      const earned = Number(this.earnedScore || 0);
      const max = Number(this.maxScore || 0);
      if (max <= 0) return 'listing-score-field--neutral';
      if (earned >= max) return 'listing-score-field--green';
      if (earned > 0) return 'listing-score-field--yellow';
      return 'listing-score-field--red';
    },
    scoreAdvice() {
      if (Number(this.maxScore) <= 0) {
        return 'Field ini tidak memiliki bobot score untuk tipe properti ini.';
      }
      if (Number(this.earnedScore) >= Number(this.maxScore)) {
        return 'Skor maksimal untuk field ini sudah tercapai.';
      }
      if (this.fieldCode === 'PHOTO_COUNT' && this.targetValue) {
        return `Tambahkan ${this.targetValue} foto properti untuk memperoleh skor maksimal.`;
      }

      return FIELD_ADVICE[this.fieldCode] || 'Lengkapi field ini untuk meningkatkan skor listing.';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/utils/variables';

.listing-score-field {
  display: block;
  width: 100%;
  max-width: 100%;
  position: static;
  clear: both;
  overflow: visible;
  box-sizing: border-box;
  margin: 4px 0 10px;
  color: $color-success;
  font-family: Poppins-SemiBold;
  font-size: 11px;
  line-height: 1.4;

  &--red {
    color: $color-beliruma-1;
    .listing-score-field__hint-icon {
      color: $color-beliruma-1;
    }
  }

  &--yellow {
    color: #b78103;
    .listing-score-field__hint-icon {
      color: #b78103;
    }
  }

  &--green {
    color: $color-success;
    .listing-score-field__hint-icon {
      color: $color-success;
    }
  }

  &--neutral {
    color: $color-text-gray-2;
    .listing-score-field__hint-icon {
      color: $color-text-gray-2;
    }
  }

  &__hint {
    display: flex;
    width: 100%;
    max-width: 100%;
    position: static;
    align-items: flex-start;
    gap: 3px;
    margin-top: 2px;
    color: $color-text-gray-2;
    font-family: Poppins, sans-serif;
    font-size: 10px;
    line-height: 1.4;
    white-space: normal;
    overflow-wrap: anywhere;

    > span:last-child {
      min-width: 0;
    }

    &-icon {
      display: inline-block;
      flex: 0 0 auto;
      position: static;
      width: auto;
      height: auto;
      color: $color-success;
      margin-top: 1px;
      line-height: 1;
    }
  }
}
</style>
